/**
 * @param {Object} options
 * @param {Vue}    options.vm         Vue component instance (this)
 * @param {String} options.base64     Base64 KML content
 * @param {String} options.filename   Target filename (e.g. polygon.kml)
 * @param {String} options.inputRef   Vue ref name (default: "kmlInput")
 * @param {String} options.mimeType   MIME type override (optional)
 *
 * @returns {Boolean}
 */
export function autoReplaceWithKml(options) {
  if (!options || !options.base64 || !options.filename) {
    console.warn("autoReplaceWithKml: invalid options");
    return false;
  }

  var vm = options.vm;
  var inputRef = options.inputRef || "kmlInput";
  
  var filename = options.filename || "polygon.kml";
  var ext = filename.split(".").pop().toLowerCase();

  var mimeType =
    options.mimeType ||
    (ext === "kmz"
      ? "application/vnd.google-earth.kmz"
      : "application/vnd.google-earth.kml+xml");

  // base64 to File
  // var byteString = atob(options.base64);
  var cleanBase64 = String(options.base64 || "");

  if (cleanBase64.indexOf(",") > -1) {
    cleanBase64 = cleanBase64.split(",")[1];
  }

  var byteString = atob(cleanBase64);

  var ab = new ArrayBuffer(byteString.length);
  var ia = new Uint8Array(ab);

  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  var file = new File([ab], filename, { type: mimeType });

  // locate file input
  var inputEl = null;
  var refTarget = vm && vm.$refs ? vm.$refs[inputRef] : null;

  if (refTarget) {
    if (refTarget.$el) {
      inputEl = refTarget.$el.querySelector('input[type="file"]');
    } else if (typeof refTarget.querySelector === "function") {
      inputEl = refTarget.querySelector('input[type="file"]');
    }
  }

  if (!inputEl) {
    try {
      inputEl = document.querySelector(
        'input[type="file"][data-auto-ref="' + inputRef + '"]'
      );
    } catch (e) {
      inputEl = null;
    }
  }

  if (!inputEl) {
    var inputs = document.querySelectorAll('input[type="file"]');
    for (i = 0; i < inputs.length; i++) {
      var acc = inputs[i].getAttribute("accept") || "";
      if (acc.indexOf(".kml") !== -1 || acc.indexOf(".kmz") !== -1) {
        inputEl = inputs[i];
        break;
      }
    }
  }

  if (!inputEl) {
    console.warn(
      "autoReplaceWithKml: file input not found for ref:",
      inputRef
    );
    return false;
  }

  // replace file
  var dataTransfer = new DataTransfer();
  dataTransfer.items.add(file);
  inputEl.files = dataTransfer.files;

  inputEl.dispatchEvent(new Event("change", { bubbles: true }));

  return true;
}



// WEBPACK FOOTER //
// ./src/utils/polygon-handler/autoReplaceWithKml.js